import { faLink } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { Card, Container } from 'react-bootstrap';

const services = [
    {
        categoria: 'Software',
        subcategorias: [
            'Aplicativos de coleta',
            'Web crawlers (coletores de sites)',
            'Websites personalizados',
            'Dashboards interativos',
            'Integrações via API'
        ]
    },
    {
        categoria: 'Coleta de Dados',
        subcategorias: [
            'Pesquisas presenciais e online',
            'Aplicação de questionários',
            'Coleta georreferenciada',
            'Auditorias em campo e online',
            'Extração automatizada de dados'
        ]
    },
    {
        categoria: 'Pesquisa',
        subcategorias: [
            'Pesquisa de mercado',
            'Pesquisa de opinião pública',
            'Pesquisa de satisfação',
            'Formulários de Entrevista',
            'Segmentação de público'
        ]
    },
    {
        categoria: 'Tratamento e Análise de Dados',
        subcategorias: [
            'Limpeza e padronização',
            'Cruzamento de bases',
            'Modelagem estatística',
            'Relatórios analíticos',
            'Construção de pipeline de dados ETL',
            'Análise Preditiva e Prescritiva'
        ]
    },
    {
        categoria: 'Inteligência Territorial',
        subcategorias: [
            'Mapas interativos',
            'Análise geoespacial',
            'Diagnósticos regionais',
            'Apoio a projetos',
            'Modelagem Preditiva',
            'Simulação e Análise de Cenários',
            'Relatórios Georreferenciados'
        ]
    },
    {
        categoria: 'Automação com Inteligência Artificial',
        subcategorias: [
            'Atendimento automatizado via WhatsApp',
            'Notificações inteligentes (e-mail, WhatsApp, etc.)',
            'Automação de fluxos de trabalho',
            'Robôs para tarefas repetitivas',
            'Integração entre sistemas'
        ]
    }
];

// Transforma as categorias em uma sequência de serviços
const serviceItems = services.flatMap(item =>
    item.subcategorias.map(subcategoria => ({
        categoria: item.categoria,
        subcategoria
    }))
);

const AdvertisementPanel = ({
    title = 'TerraData Pesquisa e Tecnologia',
    description = 'Desvendando a Terra com tecnologia e precisão.',
    image,
    link,
    height = 110,
    className = '',
    interval = 3000
}) => {

    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setActiveIndex(current =>
                (current + 1) % serviceItems.length
            );
        }, interval);

        return () => clearInterval(timer);
    }, [interval]);

    const activeService = serviceItems[activeIndex];

    const content = (
        <Card
            className={`w-100 border rounded ${className}`}
            style={{
                height: `${height}px`,
                overflow: 'hidden',
                backgroundColor: '#f8f9fa'
            }}
        >
            <Card.Body className="d-flex align-items-center gap-3 py-2 px-3 flex-nowrap">

                {/* Identidade do anunciante */}
                <div className="d-flex align-items-center gap-3 overflow-hidden flex-shrink-0"
                    style={{ maxWidth: '38%' }}>

                    {image && (
                        <img
                            src={image}
                            alt={title}
                            style={{
                                height: `${height - 24}px`,
                                maxWidth: '140px',
                                objectFit: 'contain'
                            }}
                        />
                    )}

                    <div className="overflow-hidden">
                        <small className="text-muted d-block">
                            PUBLICIDADE
                        </small>

                        <strong className="text-truncate d-block">
                            {title}
                        </strong>

                        <span className="text-muted text-truncate d-block small">
                            {description}
                        </span>
                    </div>
                </div>

                {/* Bloco animado de serviços */}
                <div
                    className="advertisement-services flex-grow-1 overflow-hidden"
                    style={{ minWidth: 0 }}
                    aria-live="polite"
                >
                    <div
                        key={activeIndex}
                        className="advertisement-services__content"
                    >
                        <small className="text-primary fw-bold d-block text-truncate">
                            {activeService.categoria}
                        </small>

                        <span className="d-block text-dark text-truncate">
                            {activeService.subcategoria}
                        </span>
                    </div>
                </div>

                {/* Botão de acesso */}
                {link && (
                    <span className="btn btn-primary btn-sm ms-auto flex-shrink-0">
                        <FontAwesomeIcon icon={faLink} />&nbsp;&nbsp;Saiba mais
                    </span>
                )}

            </Card.Body>
        </Card>
    );

    return (
        <>
            <style>
                {`
                    .advertisement-services__content {
                        animation: advertisementFade 0.7s ease both;
                    }

                    @keyframes advertisementFade {
                        from {
                            opacity: 0;
                            transform: translateY(10px);
                        }
                        to {
                            opacity: 1;
                            transform: translateY(0);
                        }
                    }

                    @media (max-width: 767px) {
                        .advertisement-services {
                            display: none;
                        }
                    }
                `}
            </style>

            <Container fluid className="px-0 my-2">
                {link ? (
                    <a
                        href={link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-decoration-none"
                    >
                        {content}
                    </a>
                ) : content}
            </Container>
        </>
    );
};

export default AdvertisementPanel;